export default "__VITE_ASSET__CHh4n9PF__"